var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "batch-progress-tab" },
    [
      _c(
        "div",
        { staticClass: "tab-toolbar" },
        [
          _c("div", { staticClass: "summary" }, [
            _c("span", { staticClass: "item" }, [
              _vm._v(" In Progress "),
              _c("strong", { staticClass: "warning" }, [
                _vm._v(_vm._s(_vm.sendingTasks.length)),
              ]),
            ]),
            _c("span", { staticClass: "item" }, [
              _vm._v(" Pending Retry "),
              _c("strong", { staticClass: "danger" }, [
                _vm._v(_vm._s(_vm.pendingRetryTasks.length)),
              ]),
            ]),
          ]),
          _c(
            "el-select",
            {
              staticStyle: { width: "160px" },
              attrs: { size: "small" },
              on: { change: _vm.onFilterChange },
              model: {
                value: _vm.statusFilter,
                callback: function ($$v) {
                  _vm.statusFilter = $$v
                },
                expression: "statusFilter",
              },
            },
            [
              _c("el-option", {
                attrs: { label: "All Visible", value: "all" },
              }),
              _c("el-option", {
                attrs: { label: "In Progress", value: "sending" },
              }),
              _c("el-option", {
                attrs: { label: "Pending Retry", value: "failed" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.pinnedSendingTasks.length
        ? _c(
            "div",
            { staticClass: "sending-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(" In Progress "),
                _c("span", [
                  _vm._v(
                    "(" +
                      _vm._s(_vm.pinnedSendingTasks.length) +
                      _vm._s(
                        _vm.hiddenSendingCount
                          ? ` / ${_vm.sendingTasks.length}`
                          : ""
                      ) +
                      ")"
                  ),
                ]),
              ]),
              _vm._l(_vm.pinnedSendingTasks, function (task) {
                return _c(
                  "div",
                  { key: task.id, staticClass: "sending-row" },
                  [
                    _c(
                      "div",
                      { staticClass: "sending-meta" },
                      [
                        _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "warning" } },
                          [_vm._v("Sending")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            attrs: { title: task.title },
                          },
                          [_vm._v(_vm._s(task.title))]
                        ),
                        _c("span", { staticClass: "muted" }, [
                          _vm._v(
                            _vm._s(task.sent) + " / " + _vm._s(task.total)
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c("el-progress", {
                      attrs: {
                        percentage: _vm.getPercent(task),
                        "stroke-width": 8,
                        color: "#d52b1e",
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm.hiddenSendingCount > 0
                ? _c("div", { staticClass: "more-sending" }, [
                    _vm._v(
                      " +" +
                        _vm._s(_vm.hiddenSendingCount) +
                        " more sending tasks are in the table below "
                    ),
                  ])
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "table-section" },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.pagedTasks,
                size: "small",
                border: "",
                "highlight-current-row": "",
              },
              on: { "row-click": _vm.onRowClick },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "createdAt", label: "Created", width: "150" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "title",
                  label: "Task",
                  "min-width": "220",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "pushType", label: "Type", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { label: "Status", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusTagType(row),
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.displayStatusLabel(row)) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Progress", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "cell-progress",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [
                            _c("el-progress", {
                              attrs: {
                                percentage: _vm.getPercent(row),
                                "stroke-width": 8,
                                status:
                                  row.status === "sending"
                                    ? undefined
                                    : row.failed > 0
                                    ? "exception"
                                    : "success",
                                color:
                                  row.status === "sending"
                                    ? "#d52b1e"
                                    : undefined,
                              },
                            }),
                            _c("span", { staticClass: "muted" }, [
                              _vm._v(
                                _vm._s(row.sent) + "/" + _vm._s(row.total)
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Result", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "success" }, [
                          _vm._v(_vm._s(row.success)),
                        ]),
                        _vm._v(" / "),
                        _c(
                          "span",
                          {
                            staticClass: "failed",
                            class: { danger: row.failed > 0 },
                          },
                          [_vm._v(_vm._s(row.failed))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Operation", width: "170", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [
                            row.failed > 0
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDrawer(row)
                                        },
                                      },
                                    },
                                    [_vm._v("Failures")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDrawer(row)
                                        },
                                      },
                                    },
                                    [_vm._v("Resend")]
                                  ),
                                ]
                              : _c("span", { staticClass: "muted" }, [
                                  _vm._v("—"),
                                ]),
                          ],
                          2
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pager" },
            [
              _c("el-pagination", {
                attrs: {
                  small: "",
                  layout: "total, prev, pager, next",
                  "current-page": _vm.currentPage,
                  "page-size": _vm.pageSize,
                  total: _vm.filteredTasks.length,
                },
                on: {
                  "update:currentPage": function ($event) {
                    _vm.currentPage = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.currentPage = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Failed Recipients",
            visible: _vm.drawerVisible,
            width: "720px",
            "append-to-body": "",
            "custom-class": "batch-progress-failure-dialog",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
            closed: _vm.onDrawerClosed,
          },
        },
        [
          _vm.activeTask
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "drawer-summary" }, [
                    _c("div", [
                      _vm._v("Task: " + _vm._s(_vm.activeTask.title)),
                    ]),
                    _c("div", [
                      _vm._v(" Failed: "),
                      _c("strong", [_vm._v(_vm._s(_vm.activeTask.failed))]),
                    ]),
                  ]),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.failures,
                        size: "mini",
                        border: "",
                        "max-height": "420",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "HCP Name",
                          "min-width": "90",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "hcpId",
                          label: "HCP ID",
                          "min-width": "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "hospital",
                          label: "Hospital",
                          "min-width": "140",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "reason",
                          label: "Reason",
                          "min-width": "130",
                          "show-overflow-tooltip": "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeDrawer } }, [
                _vm._v("Close"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.resending },
                  on: { click: _vm.onResend },
                },
                [_vm._v(" One-click Resend ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }